"use client";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
const s = ({
  title: r,
  titleId: l,
  desc: i,
  descId: n,
  ...o
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "-.5 -.5 16 16",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": l,
    "aria-describedby": n,
    ...o,
    children: [
      r ? /* @__PURE__ */ e("title", { id: l, children: r }) : null,
      i === void 0 ? /* @__PURE__ */ e("desc", { id: n, children: `
    Users Streamline Icon: https://streamlinehq.com
  ` }) : i ? /* @__PURE__ */ e("desc", { id: n, children: i }) : null,
      /* @__PURE__ */ e("path", { d: "M10 13.125v-1.25a2.5 2.5 0 0 0-2.5-2.5H3.75a2.5 2.5 0 0 0-2.5 2.5v1.25M3.125 4.375a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0-5 0M13.75 13.125v-1.25a2.5 2.5 0 0 0-1.875-2.4187M10 1.9563A2.5 2.5 0 0 1 10 6.8" })
    ]
  }
);
export {
  s as default
};
